import React from "react"
import { injectIntl } from "react-intl"
import sharedMessages from "../../messages/index"
import { isClient, CON_TOP_MUSEUM_HOSTNAME } from "../../constants";

//https://github.com/ryanflorence/react-training/blob/gh-pages/lessons/05-wrapping-dom-libs.md

class DeepZoom extends React.Component {
  render() {
    const backgroundColor = isClient && (window.location.hostname === CON_TOP_MUSEUM_HOSTNAME) ? "white" : undefined

    return (
      <div
        id="seadragon"
        className="c-mviewer__object state-canvas-cover"
        style={{ backgroundColor: backgroundColor }}
        ref={el => (this._el = el)}
      />
    )
  }

  componentDidMount() {
    this.OpenSeaDragon = require("openseadragon")
    this._renderSeaDragon()
  }

  componentWillReceiveProps(newProps) {
    if (newProps.url !== this.props.url) {
      this._renderSeaDragon(newProps)
    }
  }

  _renderSeaDragon = props => {
    props = props || this.props

    if (this._el && this.OpenSeaDragon) {
      if (this._viewer) {
        this._viewer.destroy()
      }

      //single image args
      const $args = {
        element: this._el,
        tileSources: props.url,
        // set empty default UI sources, as we aren't using them and don't want them downloading or 404ing
        navImages: {
          zoomIn: {
            REST: "",
            GROUP: "",
            HOVER: "",
            DOWN: ""
          },
          zoomOut: {
            REST: "",
            GROUP: "",
            HOVER: "",
            DOWN: ""
          },
          home: {
            REST: "",
            GROUP: "",
            HOVER: "",
            DOWN: ""
          },
          fullpage: {
            REST: "",
            GROUP: "",
            HOVER: "",
            DOWN: ""
          },
          rotateleft: {
            REST: "",
            GROUP: "",
            HOVER: "",
            DOWN: ""
          },
          rotateright: {
            REST: "",
            GROUP: "",
            HOVER: "",
            DOWN: ""
          },
          previous: {
            REST: "",
            GROUP: "",
            HOVER: "",
            DOWN: ""
          },
          next: {
            REST: "",
            GROUP: "",
            HOVER: "",
            DOWN: ""
          }
        },

        // VIEW CONTRAINTS
        // minZoomLevel: 0.5, //let people zoom out enough to make sure no chance of menus overlapping
        viewportMargins: { top: 18, right: 15, bottom: 102, left: 15 }, //restrict initial viewport to allow for menus/overlaps etc... should match mviewer.scss c-mviewer__object.state-canvas-contain
        maxZoomPixelRatio: 3, //allow zooming in above 1/1 pixel density... cos some people want to look closer despite blur! their choice :)
        constrainDuringPan: true, //prevent panning 'out of bounds' of image
        visibilityRatio: 1.0, //prevent panning 'out of bounds' of image

        //BUTTONS
        zoomInButton: "sd-zoom-in",
        zoomOutButton: "sd-zoom-out",
        homeButton: "sd-home",
        nextButton: "sd-next",
        previousButton: "sd-previous"
      }

      this._viewer = this.OpenSeaDragon($args)
      // this._viewer = OpenSeaDragon($multiargs);

      this._viewer.innerTracker.scrollHandler = false //allow users to scroll natively to avoid them getting 'stuck' in seadragon viewer. they can still doubleclick/tap to zoom or use the buttons.

      //This hack needed or images don't show on mobile devices
      setTimeout(() => {
        //global._sd = this._viewer;
        //console.log(this._viewer.viewport.getZoom());
        this._viewer.viewport.zoomTo(this._viewer.viewport.getZoom() + 0.01)
        const intl = props.intl
        document
          .getElementById($args.zoomInButton)
          .setAttribute("title", intl.formatMessage(sharedMessages.zoomIn))
        document
          .getElementById($args.zoomOutButton)
          .setAttribute("title", intl.formatMessage(sharedMessages.zoomOut))
      }, 700)
    }
  }

  componentWillUnmount() {
    this._viewer.destroy()
    this._viewer = null
  }

  shouldComponentUpdate(props) {
    return false
  }
}
export default injectIntl(DeepZoom)



// WEBPACK FOOTER //
// ./webapp/components/elements/DeepZoom.js